<form [formGroup]="formData" novalidate (ngSubmit)="onSubmit()">
  <div class="modal-header">
    <h4 class="modal-title">{{ pageTitle }}</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.dismiss('')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label for="" [translate]="'SUPPLIER.SUPPLIER_NAME'">Supplier Name</label>
          <input class="form-control" type="text" formControlName="factory_name" />
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls.factory_name"
          >
          </control-messages>
        </div>
        <div class="form-group">
          <label for="" [translate]="'SUPPLIER.SUPPLIER_DESCRIPTION'"
            >Supplier Description</label
          >
          <input
            class="form-control"
            type="text"
            formControlName="factory_description"
          />
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls.factory_description"
          >
          </control-messages>
        </div>

        <ng-container
          *ngIf="!('utah-UTAH-219-hide_supplier_admin_field' | featureFlag)"
        >
          <div class="form-group" *ngIf="authService.loginUser.role > 8">
            <label for="" [translate]="'SUPPLIER.SUPPLIER_ADMIN'"
              >Supplier Admin</label
            >
            <select
              class="form-control text-capitalize"
              formControlName="factory_admin_id"
            >
              <option
                class="text-capitalize"
                *ngFor="let staff of factoryAdmins"
                [value]="staff.id"
              >
                {{ staff.firstname }} {{ staff.lastname }}
              </option>
            </select>
            <control-messages
              [submitted]="submitted"
              [control]="formData.controls.factory_admin_id"
            >
            </control-messages>
          </div>
        </ng-container>

        <fieldset>
          <legend>Supplier Address</legend>
          <div class="form-group">
            <label for="" [translate]="'ADDRESS.STREET_ADDRESS'"
              >Street Address</label
            >
            <input
              class="form-control"
              type="text"
              formControlName="street_address"
            />
            <control-messages
              [submitted]="submitted"
              [control]="formData.controls.street_address"
            >
            </control-messages>
          </div>
          <div class="form-group">
            <label for="" [translate]="'ADDRESS.CITY_ADDRESS'">City</label>
            <input class="form-control" type="text" formControlName="city" />
            <control-messages
              [submitted]="submitted"
              [control]="formData.controls.city"
            >
            </control-messages>
          </div>
          <div class="form-group">
            <label for="" [translate]="'ADDRESS.STATE_ADDRESS'">State</label>
            <input class="form-control" type="text" formControlName="state" />
            <control-messages
              [submitted]="submitted"
              [control]="formData.controls.state"
            >
            </control-messages>
          </div>
          <div class="form-group">
            <label for="" [translate]="'ADDRESS.ZIP_CODE'">zip</label>
            <input class="form-control" type="text" formControlName="zip" />
            <control-messages
              [submitted]="submitted"
              [control]="formData.controls.zip"
            >
            </control-messages>
          </div>
          <div class="form-group">
            <label for="" [translate]="'ADDRESS.COUNTRY'">Country</label>
            <cnc-ui-countries
              [initialValue]="formData?.value?.country"
              [required]="true"
              (changeCountry)="onCountryChange($event)"
            ></cnc-ui-countries>
            <control-messages
              [submitted]="submitted"
              [control]="formData.controls.country"
            >
            </control-messages>
          </div>

          <div class="form-group">
            <label>Default Payment Terms</label>
            <select
              class="form-control text-capitalize"
              formControlName="default_payment_term"
            >
              <option
                *ngFor="let term of paymentTerms$ | async; trackBy: trackByLabel"
                [value]="term?.label"
                class="text-capitalize"
              >
                {{ term?.label }}
              </option>
            </select>
            <control-messages
              [submitted]="submitted"
              [control]="formData.controls.default_payment_term"
            >
            </control-messages>
          </div>
        </fieldset>
      </div>

      <div class="col-md-6">
        <fieldset>
          <legend>Bank Details</legend>
          <div class="form-group">
            <label for="">Bank Name</label>
            <input class="form-control" type="text" formControlName="bank_name" />
          </div>
          <div class="form-group">
            <label for="">Routing Number</label>
            <input
              class="form-control"
              type="text"
              formControlName="routing_number"
            />
          </div>
          <div class="form-group">
            <label for="">Account Number</label>
            <input
              class="form-control"
              type="text"
              formControlName="account_number"
            />
          </div>
          <div class="form-group">
            <label for="">Swift Code</label>
            <input class="form-control" type="text" formControlName="swift_code" />
            <control-messages
              [submitted]="submitted"
              [control]="formData.controls.swift_code"
            >
            </control-messages>
          </div>
        </fieldset>
        <fieldset>
          <legend class="d-flex justify-content-between align-end">
            Contact Details

            <a class="text-small text-primary" (click)="onOpenContactDialog()">
              <i class="fa fa-plus"></i> Add Contact Details</a
            >
          </legend>
          <div class="form-group">
            <lum-ui-autocomplete
              placeholder="Search Contact"
              [debounceTime]="500"
              [options]="contacts"
              [displayProperty]="'contactName'"
              (inputChangeEvent)="onChangeContactEvent($event)"
              (optionSelectedEvent)="onSelectContactEvent($event)"
            ></lum-ui-autocomplete>

            <table class="lum-table lum-table--classic">
              <tbody>
                <tr *ngFor="let contact of contactsControl.value">
                  <td>{{ contact.contactName }}</td>
                  <td>{{ contact.contactEmail }}</td>
                  <td>
                    <i
                      class="fa fa-trash text-red-500 cursor-pointer"
                      (click)="onRemoveContact(contact)"
                    ></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </fieldset>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-danger"
      (click)="activeModal.dismiss('')"
      [translate]="'BUTTONS.CLOSE'"
    >
      <i class="fas fa-times"></i> Close
    </button>
    <button
      type="submit"
      [ngClass]="{
        'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading,
      }"
      [disabled]="loading"
      id="kt_submit"
      class="btn btn-primary btn-elevate kt-btn-primary"
      [translate]="'BUTTONS.SAVE'"
    >
      <i class="fas fa-save"></i> Save
    </button>
  </div>
</form>
